module.exports = __webpack_public_path__ + "static/media/limon_big.dd17dc81.png";